import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberMessagesPage from "@/pages/member/MemberMessagesPage";

export const Route = createFileRoute("/member/messages")({
  head: () => pageHead("Member · Messages", "AKIVA member · messages portal.", "/member/messages", true),
  component: MemberMessagesPage,
});
